export class InductionRequirementsFakeDb {
  public static requirements = [];
}
